'use client';

import { useUpdateGlobalUser } from '@/hooks/useUpdateGlobalUser';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React, { useEffect } from 'react';
import { CurrencySign } from '../CurrencySign';

type Props = {
  onClose: () => void;
  amountPurchased?: string;
  resultBalance?: string;
  productId?: string;
  paidAmount?: number;
  paidCurrencySign?: string;
};

export const FinalScreen: React.FC<Props> = ({
  onClose,
  resultBalance,
  amountPurchased,
  productId,
  paidAmount,
  paidCurrencySign,
}) => {
  const t = useTranslations('monetization');

  const reloadUser = useUpdateGlobalUser();

  useEffect(() => {
    reloadUser();
  }, [reloadUser]);

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <div className='flex flex-col gap-[12px] items-center'>
          {productId ? (
            <>
              <Image alt='' src='/assets/images/after_top_up.webp' width={289} height={250} />

              <DialogTitle asChild>
                <div className='self-center text-[18px] font-semibold text-text-primary-day'>
                  {t('product_promoted')}
                </div>
              </DialogTitle>

              <div className='self-center text-[16px] text-text-primary-day'>{t('product_promoted_text')}</div>

              {paidAmount !== undefined && paidCurrencySign && (
                <div className='self-center text-[18px] font-semibold text-text-primary-day'>
                  {paidAmount} <CurrencySign value={paidCurrencySign} />
                </div>
              )}

              <Button onClick={onClose} className='w-full h-auto py-[10px]'>
                {t('ok_button')}
              </Button>
            </>
          ) : (
            <>
              <Image alt='' src='/assets/images/many_coins.png' width={120} height={104} />

              <DialogTitle asChild>
                <div className='self-center text-[18px] font-semibold text-text-primary-day'>
                  {t('you_bought_amount', { value: amountPurchased || 0 })}
                </div>
              </DialogTitle>

              <div className='self-center text-[16px] text-text-primary-day'>
                {t('your_balance_after_purchase', { value: resultBalance || 0 })}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
